import { faker } from '@faker-js/faker'

/**
 *
 */
export default function mockAccount({ override = {} } = {}) {
  const account = {
    id: faker.string.uuid(),
    email: `${faker.lorem.word()}@buffer.com`,
    createdAt: faker.date.past({ years: 2 }),
    featureFlips: ['facebookInEngage'],
    isImpersonation: false,
    currentOrganization: null,
    organizations: [],
    products: [
      { name: 'publish', userId: faker.string.uuid() },
      { name: 'engage', userId: faker.string.uuid() },
    ],
  }

  return {
    ...account,
    ...override,
  }
}
